import { TranslationKeys } from "@/contexts/TranslationKeys";
import { MultiSelectOption } from "@/models/MultiSelectOption";
import { getGlobalTranslator } from "@/services/utilities/ServiceError";

export const typeOptions: MultiSelectOption[] = [
    { value: "0", label: getGlobalTranslator().byKey(TranslationKeys.doorGroup) },
    { value: "1", label: getGlobalTranslator().byKey(TranslationKeys.door) },
];

export const unlockTimeOptions: MultiSelectOption[] = [
    { value: "0", label: getGlobalTranslator().byKey(TranslationKeys.defaultUnlockTime) },
    { value: "1", label: getGlobalTranslator().byKey(TranslationKeys.extendedUnlockTime) },
];

export const toggleOptions: MultiSelectOption[] = [
    { value: "0", label: getGlobalTranslator().byKey(TranslationKeys.inactive) },
    { value: "1", label: getGlobalTranslator().byKey(TranslationKeys.active) },
];